import { render, staticRenderFns } from "./Oct.vue?vue&type=template&id=b26aef04"
import script from "./Oct.vue?vue&type=script&lang=js"
export * from "./Oct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports